import Vue from 'vue';
import Translation from '../components/common/Translation';
import store from '../store';
import staticTranslations from '../translations/obelix.translations.json'

Vue.component('t', Translation);

Vue.prototype.$t = function (key, language) {
    let text;
    if (!staticTranslations) return '';
    if (!language) language = store.getters.language;
    let texts = staticTranslations[key];
    text = texts ? texts[language] : null;
    return text || '❔ ' + key + ' ❔';
}
